<ngx-spinner name="{{name}}" bdColor="rgba(0, 0, 0, 0.5)" size="medium" color="#bd0007" type="triangle-skew-spin" [fullScreen]="true">
  <img src="assets/img/logo-thailandpost.png" alt="">
</ngx-spinner>